// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiCitas: {
    context: "/CONOCERBACKCITAS/evento/",
    methods: {
      create: "crearEvento",
      catalog: "getCatalogos",
      hourByDate: "getHorariosByFecha",
      summary: "resumenCitas",
      status: "statusUpdate",
    },
  },
  apiSectores: {
    context: "/CONOCERBACKCITAS/sectoresProductivos/",
    methods: {
      general: "generales",
      standar: "estandares",
      standarDescription: "getDescEstandar",
      certifierDescription: "getDesCertificador",
      generalData: "getDatosGeneralesComite",
      brandStandards: "getEstandaresMarca",
      allStandars: "getEstandaresAll",
      generalStandar: "generales/estandar",
      courses: "cursos",
      fichaEstandar: "fichaEstandar",
    },
  },
  apiSectoresOrg: {
    context: "/CONOCERBACKCITAS/sectoresOcupacionales/",
    methods: {
      ocupaciones: "ocupacion",
      nieveles: "nivel",
      estandares: "estandares",
      getDadAndId: "getDAD",
      getNivelXSector: "getNivelXSector",
    },
  },
  apiCursos: {
    context: "/CONOCERBACKCITAS/renac/",
    methods: {
      listaCursos: "listaDeCursos",
      detalleCurso: "detalleCurso",
    },
  },
  apiCompetencias: {
    context: "/CONOCERBACKCITAS/renap/",
    methods: {
      listaCursos: "lista",
    },
  },
  apiPrestadorServ: {
    context: "/CONOCERBACKCITAS/prestador-servicios/",
    methods: {
      organisms: "organismos",
      entities: "entidades",
    },
  },
  apiComite: {
    context: "/CONOCERBACKCITAS/comites/",
    methods: {
      active: "activos"
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
